import { T_Pool } from '@/ts/types/T_Pool';

export const calculateTokensRemaining = (token: T_Pool): string => {
  const totalSupply = parseFloat(token.totalSupply) || 0;
  const tokensSold = parseFloat(
    token?.blockchainData?.totalSoldTokensDecimal || '0'
  );

  // Validate values to prevent NaN or Infinity
  const validTotalSupply =
    isFinite(totalSupply) && !isNaN(totalSupply) ? totalSupply : 0;
  const validTokensSold =
    isFinite(tokensSold) && !isNaN(tokensSold) ? tokensSold : 0;

  const remaining = validTotalSupply - validTokensSold;

  // Consider dust (very small remaining amount) as 0 to preventing purchasing when effectively sold out
  if (remaining < 0.01) {
    return '0';
  }

  // Ensure remaining is not negative
  return Math.max(0, remaining).toString();
};
